import React from 'react'
import {
  Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Typography
} from '@mui/material'
import { type AssetHolderSettlementProps } from '../../../../api/schema-dtos/SettlementDomainDtos'
import { styled } from '@mui/material/styles'

const ProjectSettlements: React.FC<AssetHolderSettlementProps> = ({ settlementDto }: AssetHolderSettlementProps) => {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.action.hover,
      fontWeight: 700
      // color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      // fontSize: 14,
      fontWeight: 400
    }
  }))

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
      backgroundColor: theme.palette.action.hover
    }
    // hide last border
    // '&:last-child td, &:last-child th': {
    //   border: 0
    // }
  }))

  const currencyCode = settlementDto.currencyCode

  return (
    <>
      <Typography variant={'h3'} sx={{ mb: 2 }}>Project Settlements</Typography>
      <TableContainer>
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRow>
              <StyledTableCell>Project</StyledTableCell>
              <StyledTableCell align="center">Total solar cells</StyledTableCell>
              <StyledTableCell align="right">Cost of solar cells ({currencyCode})</StyledTableCell>
              <StyledTableCell align="right">Total earnings ({currencyCode})</StyledTableCell>
              <StyledTableCell align="right" width={'15%'}>Settlement Amount</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {settlementDto.projectSettlements.map((row) => (
              <StyledTableRow
                key={row.projectId}
                // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <StyledTableCell>{row.projectName}</StyledTableCell>
                <StyledTableCell align="center">{row.countCells}</StyledTableCell>
                <StyledTableCell align="right">{row.totalCostAmountFormatted}</StyledTableCell>
                <StyledTableCell align="right">{row.totalEarningsAmountFormatted}</StyledTableCell>
                <StyledTableCell align="right">{row.settlementAmountFormatted}</StyledTableCell>
              </StyledTableRow>
            ))}

            <StyledTableRow>
              <TableCell colSpan={6} align="right">{settlementDto.settlementTotalAmountFormatted}</TableCell>
            </StyledTableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

export default ProjectSettlements
